// extracted by mini-css-extract-plugin
export const shorexDisclaimer = "CruiseItinerary-module--shorex-disclaimer--KTXMT";